import React from 'react';


import Backdrop from './Backdrop2';

import styled from 'styled-components';

const Spinner = styled.div`
    width: auto;
    padding:1% 2%;
    position: fixed;
    z-index: 70000;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    top: 82%;
    left: calc(10%);
    background: white;
    border-radius: 5px;
    box-shadow:2px 2px 20px 8px #E9EBEC;
    img{
      width: 30px;
      height: 30px;
      float:leeft;
    }
    p{
      float: right;
      padding: 2px 10px;
      margin: 0;
      font-weight: 500;
      font-size: 18px;
    }
`
const primaryModal = (props) => (
   <div>
     {/* <Backdrop clicked={props.closeModal} show={props.show} /> */}
     <Spinner
     style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? '1': '0'

    }}
     >
      {props.children}
    </Spinner>
   </div>
);

export default primaryModal;